import React from 'react';
import PropTypes from 'prop-types';
import WizardLayout from './WizardLayout';
import AddStudentWizardProvider from './AddStudentWizardProvider';

const Wizard = ({ variant, validation, progressBar }) => {
  return (
    <AddStudentWizardProvider>
      <WizardLayout
        variant={variant}
        validation={validation}
        progressBar={progressBar}
      />
    </AddStudentWizardProvider>
  );
};

Wizard.propTypes = {
  variant: PropTypes.oneOf(['pills']),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool
};

export default Wizard;
